(function () {
  if (customElements.get('cart-upsell')) return;

  var MAX_ITEMS = 8;

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  function toCents(v) {
    if (v == null) return 0;
    return typeof v === 'string' ? Math.round(parseFloat(v) * 100) : v;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  }
  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  // Drawer ka naya HTML server se la kar drawer mai laga do (bina page refresh)
  async function refreshDrawer(fromEl) {
    var wrap = fromEl.closest('.shopify-section') || document.querySelector('[id^="shopify-section-cart-drawer"]');
    var sectionId = wrap && wrap.id ? wrap.id.replace('shopify-section-', '') : 'cart-drawer-section';
    var res = await fetch('/?section_id=' + encodeURIComponent(sectionId) + '&t=' + Date.now());
    if (!res.ok) throw new Error('section fetch failed ' + res.status);
    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
    var current = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
    if (!fresh || !current) return;
    current.className = fresh.className;
    current.innerHTML = fresh.innerHTML;
  }

  class CartUpsell extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('[data-track]');

      this._onClick = function (e) {
        var prev = e.target.closest('[data-prev]');
        var next = e.target.closest('[data-next]');
        if (prev || next) {
          self.track.scrollBy({ left: (prev ? -1 : 1) * self.track.clientWidth, behavior: 'smooth' });
          return;
        }
        var add = e.target.closest('[data-add]');
        if (add) self.add(add);
      };
      this.addEventListener('click', this._onClick);

      // Cart badalte hi dobara products load (har add par naye products)
      this._onCart = function () {
        clearTimeout(self._t);
        self._t = setTimeout(function () { self.load(); }, 350);
      };
      document.addEventListener('cart:update', this._onCart);

      // Agar theme drawer refresh karte waqt track khali kar de to cache se wapis bhar do
      this._mo = new MutationObserver(function () {
        if (self._rendering) return;
        var cache = window.__cartUpsellCache;
        if (cache && cache.length && self.track) {
          if (!self.track.children.length) self.render(cache);
          else if (self.hidden) self.hidden = false;
        }
      });
      this._mo.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });

      if (window.__cartUpsellCache) this.render(window.__cartUpsellCache);
      this.load();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      document.removeEventListener('cart:update', this._onCart);
      if (this._mo) this._mo.disconnect();
    }

    async load() {
      if (this._busy) return;
      this._busy = true;
      try {
        var cart = await getJSON('/cart.js');
        if (!cart.items.length) {
          window.__cartUpsellCache = null;
          this.hidden = true;
          return;
        }
        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.product_id] = true; });

        // Sabse naya add hua item pehle aata hai: us ke hisaab se recommendations
        var seeds = cart.items.slice(0, 3).map(function (i) { return i.product_id; });
        seeds = seeds.filter(function (v, i) { return seeds.indexOf(v) === i; });

        var lists = await Promise.all(seeds.map(function (id) {
          return getJSON('/recommendations/products.json?product_id=' + id + '&limit=10&intent=related')
            .then(function (j) { return j.products || []; })
            .catch(function () { return []; });
        }));

        var seen = {};
        var out = [];
        // round-robin: latest item ke products pehle
        for (var n = 0; n < 10; n++) {
          for (var k = 0; k < lists.length; k++) {
            var p = lists[k][n];
            if (!p || inCart[p.id] || seen[p.id] || p.available === false) continue;
            seen[p.id] = true;
            out.push(p);
          }
        }

        // Kam hon to store ke aur products se top-up
        if (out.length < 4) {
          try {
            var all = await getJSON('/collections/all/products.json?limit=24');
            (all.products || []).forEach(function (p) {
              if (out.length >= MAX_ITEMS || inCart[p.id] || seen[p.id]) return;
              if (!p.variants || !p.variants.some(function (v) { return v.available; })) return;
              seen[p.id] = true;
              p.featured_image = p.images && p.images[0] ? p.images[0].src : '';
              p.url = '/products/' + p.handle;
              out.push(p);
            });
          } catch (e) {}
        }

        out = out.slice(0, MAX_ITEMS);
        window.__cartUpsellCache = out;
        this.render(out);
      } catch (e) {
        console.error('cart-upsell:', e);
      } finally {
        this._busy = false;
      }
    }

    render(products) {
      if (!this.track) return;
      this._rendering = true;
      if (!products || !products.length) {
        this.hidden = true;
        this._rendering = false;
        return;
      }
      this.track.innerHTML = products.map(function (p) {
        var variants = (p.variants || []).filter(function (v) { return v.available !== false; });
        if (!variants.length) return '';
        var v0 = variants[0];
        var price = toCents(p.price != null ? p.price : v0.price);
        var compare = toCents(p.compare_at_price != null ? p.compare_at_price : v0.compare_at_price);
        var multi = variants.length > 1 && !(variants.length === 1 && variants[0].title === 'Default Title');
        var select = multi
          ? '<select class="cart-upsell__select" data-variant aria-label="Option">' +
            variants.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') +
            '</select>'
          : '<input type="hidden" data-variant value="' + v0.id + '">';
        var image = p.featured_image && p.featured_image.url ? p.featured_image.url : p.featured_image;
        return (
          '<div class="cart-upsell__slide">' +
            '<a class="cart-upsell__img" href="' + esc(p.url) + '">' +
              (image ? '<img src="' + esc(img(image)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="cart-upsell__info">' +
              '<a class="cart-upsell__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
              '<div class="cart-upsell__price">' + money(price) +
                (compare > price ? '<s>' + money(compare) + '</s>' : '') +
              '</div>' +
              select +
            '</div>' +
            '<button type="button" class="cart-upsell__add" data-add>+ Add</button>' +
          '</div>'
        );
      }).join('');
      this.track.scrollLeft = 0;
      this.hidden = false;
      var self = this;
      setTimeout(function () { self._rendering = false; }, 0);
    }

    async add(btn) {
      var slide = btn.closest('.cart-upsell__slide');
      var field = slide && slide.querySelector('[data-variant]');
      if (!field) return;
      var label = btn.textContent;
      var variantId = Number(field.value);
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add failed');
        var cart = await getJSON('/cart.js');

        // Confirmation
        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');

        // Added product ko cache se nikaal do taake dobara na aaye
        if (window.__cartUpsellCache) {
          window.__cartUpsellCache = window.__cartUpsellCache.filter(function (p) {
            return !(p.variants || []).some(function (v) { return v.id === variantId; });
          });
        }

        // Header ka cart count wagera update karne ke liye Horizon ka event
        try {
          var events = await import('@theme/events');
          document.dispatchEvent(
            new events.CartUpdateEvent(cart, 'cart-upsell', { itemCount: cart.item_count })
          );
        } catch (e) {}

        // Drawer ko khud refresh karo (items, subtotal, free shipping bar sab)
        await refreshDrawer(this);
      } catch (e) {
        console.error('cart-upsell add:', e);
        btn.classList.remove('is-added');
        btn.textContent = label;
        btn.disabled = false;
      }
    }
  }

  customElements.define('cart-upsell', CartUpsell);
})();